var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlexibilityIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 109,
    height: 109,
    viewBox: "0 0 109 109",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M100.219 52.6649H99.4429C96.2565 38.4228 83.5383 27.7274 68.3542 27.7274H58.6562V24.1807C63.4775 22.4628 66.9688 17.8909 66.9688 12.4878C66.9688 5.61615 61.3717 0.0190628 54.5 0.0190628C47.6283 0.0190628 42.0312 5.61615 42.0312 12.4878C42.0312 17.8909 45.5225 22.4628 50.3438 24.1807V27.7274H40.6458C25.4617 27.7274 12.7435 38.4228 9.55708 52.6649H8.78125C4.20937 52.6649 0.46875 56.4055 0.46875 60.9774V69.2899C0.46875 73.8618 4.20937 77.6024 8.78125 77.6024H10.3052C13.5748 87.7991 21.8319 95.7237 32.1948 98.6053C31.419 100.24 30.9479 102.013 30.9479 103.925C30.9479 106.225 32.8044 108.082 35.1042 108.082H73.8958C76.1956 108.082 78.0521 106.225 78.0521 103.925C78.0521 102.013 77.581 100.212 76.8052 98.6053C87.1681 95.7514 95.4252 87.7991 98.6948 77.6024H100.219C104.791 77.6024 108.531 73.8618 108.531 69.2899V60.9774C108.531 56.4055 104.791 52.6649 100.219 52.6649ZM54.5 8.33156C56.7998 8.33156 58.6562 10.188 58.6562 12.4878C58.6562 14.7876 56.7998 16.6441 54.5 16.6441C52.2002 16.6441 50.3438 14.7876 50.3438 12.4878C50.3438 10.188 52.2002 8.33156 54.5 8.33156ZM68.3542 91.4566H40.6458C27.6506 91.4566 17.0938 80.8997 17.0938 67.9045V59.592C17.0938 46.5968 27.6506 36.0399 40.6458 36.0399H68.3542C81.3494 36.0399 91.9062 46.5968 91.9062 59.592V67.9045C91.9062 80.8997 81.3494 91.4566 68.3542 91.4566Z",
    fill: "url(#paint0_linear_8920_202)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2604 47.1232C34.6885 47.1232 30.9479 50.8639 30.9479 55.4357V63.7482C30.9479 68.3201 34.6885 72.0607 39.2604 72.0607C43.8323 72.0607 47.5729 68.3201 47.5729 63.7482V55.4357C47.5729 50.8639 43.8323 47.1232 39.2604 47.1232Z",
    fill: "url(#paint1_linear_8920_202)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M69.7396 47.1232C65.1677 47.1232 61.4271 50.8639 61.4271 55.4357V63.7482C61.4271 68.3201 65.1677 72.0607 69.7396 72.0607C74.3115 72.0607 78.0521 68.3201 78.0521 63.7482V55.4357C78.0521 50.8639 74.3115 47.1232 69.7396 47.1232Z",
    fill: "url(#paint2_linear_8920_202)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4894 8.1099L33.8019 10.8807C34.2452 11.0193 34.6885 11.1024 35.1042 11.1024C36.8498 11.1024 38.4569 9.99406 39.0387 8.24844C39.7592 6.05948 38.5954 3.70427 36.4065 2.98386L28.094 0.213022C25.9327 -0.507394 23.5775 0.656355 22.8294 2.84531C22.0812 5.03427 23.2727 7.38948 25.4617 8.1099H25.4894Z",
    fill: "url(#paint3_linear_8920_202)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7917 24.9566C27.235 24.9566 27.6783 24.9011 28.094 24.7349L36.4065 21.9641C38.5954 21.2436 39.7592 18.8884 39.0387 16.6995C38.3183 14.5105 35.9631 13.3468 33.7742 14.0672L25.4617 16.838C23.2727 17.5584 22.109 19.9136 22.8294 22.1026C23.4112 23.8482 25.0183 24.9566 26.764 24.9566H26.7917Z",
    fill: "url(#paint4_linear_8920_202)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M73.8958 11.1024C74.3392 11.1024 74.7825 11.047 75.1981 10.8807L83.5106 8.1099C85.6996 7.38948 86.8633 5.03427 86.1429 2.84531C85.4225 0.656355 83.0673 -0.507394 80.8783 0.213022L72.5658 2.98386C70.3769 3.70427 69.2131 6.05948 69.9335 8.24844C70.5154 9.99406 72.1225 11.1024 73.8681 11.1024H73.8958Z",
    fill: "url(#paint5_linear_8920_202)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M72.5935 21.9641L80.906 24.7349C81.3494 24.8734 81.7927 24.9566 82.2083 24.9566C83.954 24.9566 85.561 23.8482 86.1429 22.1026C86.8633 19.9136 85.6996 17.5584 83.5106 16.838L75.1981 14.0672C73.0369 13.3468 70.654 14.5105 69.9335 16.6995C69.2131 18.8884 70.3769 21.2436 72.5658 21.9641H72.5935Z",
    fill: "url(#paint6_linear_8920_202)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8920_202",
    x1: 54.5,
    y1: 0,
    x2: 54.5,
    y2: 108.082,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#674CEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#437CF3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_8920_202",
    x1: 54.5,
    y1: 0,
    x2: 54.5,
    y2: 108.082,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#674CEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#437CF3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_8920_202",
    x1: 54.5,
    y1: 0,
    x2: 54.5,
    y2: 108.082,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#674CEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#437CF3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_8920_202",
    x1: 54.5,
    y1: 0,
    x2: 54.5,
    y2: 108.082,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#674CEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#437CF3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_8920_202",
    x1: 54.5,
    y1: 0,
    x2: 54.5,
    y2: 108.082,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#674CEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#437CF3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_8920_202",
    x1: 54.5,
    y1: 0,
    x2: 54.5,
    y2: 108.082,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#674CEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#437CF3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_8920_202",
    x1: 54.5,
    y1: 0,
    x2: 54.5,
    y2: 108.082,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#674CEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#437CF3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlexibilityIcon);
export default __webpack_public_path__ + "static/media/flexibility-icon.4da378381bde964ac4e5142c8add5835.svg";
export { ForwardRef as ReactComponent };